import React from 'react'
import styles from './index.module.scss'

const LeftImageContainer = ({ heading, Image, description = "Trusted Advisory Service" }) => {
    return (
        <div className={styles.container}>
            <h2>{heading}</h2>
            <h1>WELCOME TO TAS</h1>
            <h2>{description}</h2>
            {/* <h2 style={{marginTop:'-20px'}}>Trust and Estate for Multigenerational Families</h2> */}

            <div>
                <img src={Image} alt="illustration" />
            </div>
        </div>
    );
}

export default React.memo(LeftImageContainer);